
















































































import { Prop, Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import UUIFComponent from '@/shared/uuifComponent';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { AddClaims } from '../types';
import { InfoState } from '@/core';

const cssPrefix = 'addClaimDialog';
@Component({
  components: {
    ...UUIFComponent,
    SwForm,
    SwFormRow,
    SwTextarea,
  },
})

export default class AddClaimsDialog extends SwExtendedVue {
  @Prop() addClaimsModal: boolean;
  cssPrefix = cssPrefix;
  addClaims: AddClaims = {
    serialNumber: '',
    comments: '',
  };
  showErrorMsg: boolean = false;
  hasInvalidSerialNumber: boolean = false;

  closeDialog(value:boolean = false) {
    this.$emit('closeAddClaimsDialog', value);
  }

  checkInputValidation(): boolean {
    this.showErrorMsg = true;
    if (this.addClaims.serialNumber !== '' && this.addClaims.comments !== '') {
      return true;
    }
    return false;
  }

  async submitClaims() {
    this.hasInvalidSerialNumber = false;
    const isValid = this.checkInputValidation();
    if (!isValid && this.addClaims.comments === '') {
      const message: InfoState = { infoType: 'failed', infoMsg: this.$t('partnerResources.commentRequired') as string };
      this.$store.commit('enqueueMessage', message);
    }
    if (isValid) {
      const serialNumbers:any = [];
      const userName = this.$store.getters.getUserId;
      this.addClaims.serialNumber.split(',')
       .forEach((element:any) => {
         if (!element.trim()
          .match(/^[0-9a-z]+$/i)) {
           console.warn(element);
           this.hasInvalidSerialNumber = true;
         }
         const item = {
           serialNumber: element.trim(),
           claimStatus: '',
           username: userName,
           comments: this.addClaims.comments,
         };
         if (item.serialNumber) {
           serialNumbers.push(item);
         }
       });
      if (serialNumbers.length !== 0 && !this.hasInvalidSerialNumber) {
        await this.$store.dispatch('MswPartnerResourcesModule/addClaim', serialNumbers)
          .then((response:any) => {
            if (response.operationStatus === 'OK') {
              this.showErrorMsg = false;
              this.hasInvalidSerialNumber = false;
              this.addClaims.serialNumber = '';
              this.addClaims.comments = '';
              this.showMessage('success', response.msgDesc);
              this.closeDialog(true);
            } else {
              this.addClaims.serialNumber = '';
              this.addClaims.comments = '';
              this.showMessage('failed', response.msgDesc || 'Something went wrong');
              this.closeDialog(false);
            }
          })
          .catch((errResponse:any) => {
            this.addClaims.serialNumber = '';
            this.addClaims.comments = '';
            this.showMessage('failed', errResponse.msgDesc || 'Operation is unsuccesful');
            this.closeDialog(false);
          })
          .finally(() => {
            this.$store.commit('stopLoading');
          });
      }
    }
  }

  cancelRequest() {
    this.addClaims.serialNumber = '';
    this.addClaims.comments = '';
    this.showErrorMsg = false;
    this.hasInvalidSerialNumber = false;
    this.closeDialog(false);
  }

  showMessage(infoType: string, infoMsg: string): void {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
